import React from 'react';
/*
import {
  _hm,
  _hmDTM,
  _ht,
  cr,
  a,
  ls,
  f,
  gs,
  useLdrz,
  BoxC,
  BtnC,
  GridC,
  IptC,
  LblC,
  MsgC,
  SrlC,
  TblC,
  TextC,
  _cv_31___Mz,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as LblC from "./_cccLblC";
import * as TblC from "./_ccmTblC";
import * as _cm from './_cm';
import * as _cmFTH from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import { useLdrz } from "./_csLdr";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as _ht from './_ht';
import * as _hm from './_hf';
import * as _hmDTM from './_hfDTM';

import * as icm from './icm';
import * as icv from './icv';
import * as ihd from './ihd';
import * as _hd_60 from './_hd_60';

import * as icvI18___Mz from './icvI18___Mz';
import * as icvI1z___Mz from './icvI1z___Mz';

let $i18rs = [] as _ht.ls;
let $_31rs = [] as _ht.ls;
//let $bSch = false;

const $sch = (pz: {
  sPz: _ht.dz,
  udtThis: () => void,
  bHome?: _ht.b,
  sLdrz: _ht.dz,
  pagez: _ht.dz,
}) => {
  const _gUserz = gs.useUserz();
  pz.sLdrz.show();
  icvI1z___Mz.loadI1zrLsAsync({
    _31r_fst: pz.bHome ? _gUserz.crt._31rz._fst : pz.pagez.schz?._31r_fst,
    i1zrd3100sStt: pz.bHome ? undefined: pz.pagez.schz?.sttDate,
    i1zrd3100sEnd: pz.bHome ? undefined: pz.pagez.schz?.endDate,
    i18r_fst: pz.bHome ? undefined: pz.pagez.schz?.i18r_fst,
    i1zrs1100i: pz.bHome ? 70 : (pz.sPz.crt.ctt == 'r' ? pz.pagez.schz?.i1zrs1100i : -1),
    i1zrs1200i: pz.bHome ? undefined: (pz.sPz.crt.ctt == 'e' ? pz.pagez.schz?.i1zrs1200i : -1),
    lwrType: 1,
  })
  .then((_ls: _ht.ls) => {
//    $bSch = true;
    pz.pagez.bSch = true;
    pz.pagez.i1zrs = _ls;
    pz.sLdrz.hide();
    pz.udtThis();
  })
}

export const S = (pz: {
  sPz: _ht.dz,
  frcUdt: () => void,
  pagez: _ht.dz,
}) => {
//  const _frcUdt = ls.frcUdt();
  const _udtThis = ls.udtThis();
  const _gUserz = gs.useUserz();
  const _sLdrz = useLdrz();

  React.useEffect(() => {
    if (_gUserz.crt._dmn) {
      _cmFTH.loadAllAsync({
        frcUdt: _udtThis,
        bfrAsync: () => [
          icvI18___Mz.loadI18rLsAsync()
          .then((_ls: _ht.ls) => {
            $i18rs = [{ key: -1, pfx: 'すべて'}].concat(_ls);
          }),
          _cv_31___Mz.load_31rLsAsync()
          .then((_ls: _ht.ls) => {
            $_31rs = [{ key: -1, pfx: 'すべて'}].concat(_ls);
          }),
        ],
      })
    }
  }, [
    _gUserz.crt._dmn,
  ])

  return (
    cr.c(BoxC.N, {
      key: -10,
      boxStlz: a(`fd/rsc`),
      oClds: [
        cr.c(LblC.N, {
          key: -10,
          abtType: 'ftnCmnz',
          boxStlz: a('dw/22'),
          lblCz: {
            boxStlz: a('dw/7'),
            textz: {
              pfx: '利用日',
            }
          },
          cttCz: {
            oClds: [
              cr.c(IptC.S, {
                key: -10,
                abtType: 'ftnCmnz',
                cz: {
                  bEdit: true,
                  iptType: 'dtm',
                  vle: pz.pagez.schz?.sttDate,
                  onChg: ( _s: _ht.s ) => {
                    _hm.udtDz(pz.pagez.schz, {
                      sttDate: _s,
                      endDate: _s,
                    });
                    _udtThis();                    
                  },
                }
              })
            ]
          },
        }),
        cr.c(LblC.N, {
          key: -20,
          abtType: 'ftnCmnz',
          boxStlz: a('dw/18'),
          lblCz: {
            boxStlz: a('dw/3'),
            textz: {
              pfx: '〜',
            }
          },
          cttCz: {
            oClds: [
              cr.c(IptC.S, {
                key: -10,
                abtType: 'ftnCmnz',
                cz: {
                  bEdit: true,
                  iptType: 'dtm',
                  vle: pz.pagez.schz?.endDate,
                  onChg: ( _s: _ht.s ) => {
                    _hm.udtDz(pz.pagez.schz, {
                      endDate: _s,
                    });
                  },
                }
              })
            ]
          },
        }),
        cr.c(LblC.N, {
          key: -30,
          abtType: 'ftnCmnz',
          boxStlz: a('dw/30'),
          lblCz: {
            boxStlz: a('dw/5'),
            textz: {
              pfx: '団体',
            }
          },
          cttCz: {
            oClds: [
              cr.c(IptC.S, {
                key: -10,
                abtType: 'ftnCmnz',
                cz: {
                  bEdit: true,
                  iptType: 'sch',
                  ls: $i18rs,
                  vle: pz.pagez.schz?.i18r_fst,
                  onChg: (_dz: _ht.dz) => {
                    _hm.udtDz(pz.pagez.schz, {
                      i18r_fst: _dz.key,
                    });
                    if (_dz.key > 0) {
                      _hm.udtDz(pz.pagez.schz, {
                        sttDate: '',
                        endDate: '',
                      });
                      _udtThis();
                    }
                  }
                }
              })
            ]
          },
        }),
        cr.c(LblC.N, {
          key: -40,
          abtType: 'ftnCmnz',
          boxStlz: a('dw/23'),
          lblCz: {
            boxStlz: a('dw/5'),
            textz: {
              pfx: '状況',
            }
          },
          cttCz: {
            oClds: [
              cr.c(IptC.S, {
                key: -10,
                abtType: 'ftnCmnz',
                cz: {
                  bEdit: true,
                  iptType: 'pcr',
                  ls:                   
                    pz.sPz.crt.ctt == 'r' ?
                      icv.sttz.rs
                    : pz.sPz.crt.ctt == 'e' ?
                      icv.sttz.es
                    : [],
                  vle: 
                    pz.sPz.crt.ctt == 'r' ?
                      pz.pagez.schz?.i1zrs1100i
                    : pz.sPz.crt.ctt == 'e' ?
                      pz.pagez.schz?.i1zrs1200i
                    : undefined,
                  onChg: (_dz: _ht.dz) => {
                    if (pz.sPz.crt.ctt == 'r') {
                      _hm.udtDz(pz.pagez.schz, {
                        i1zrs1100i: _dz.key,
                      });
                    }
                    if (pz.sPz.crt.ctt == 'e') {
                      _hm.udtDz(pz.pagez.schz, {
                        i1zrs1200i: _dz.key,
                      });
                    }
                  },
                },
              })
            ]
          },
        }),
        cr.c(LblC.N, {
          key: -50,
          abtType: 'ftnCmnz',
          boxStlz: a('dw/30'),
          lblCz: {
            boxStlz: a('dw/5'),
            textz: {
              pfx: '施設',
            }
          },
          cttCz: {
            oClds: [
              cr.c(IptC.S, {
                key: -10,
                abtType: 'ftnCmnz',
                cz: {
                  bEdit: true,
                  iptType: 'pcr',
                  ls: $_31rs,
                  vle: pz.pagez.schz?._31r_fst,
                  onChg: (_dz: _ht.dz) => {
                    _hm.udtDz(pz.pagez.schz, {
                      _31r_fst: _dz.key,
                    });
                  },
                },
              })
            ]
          },
        }),
        cr.c(BtnC.N, {
          key: -60,
          abtType: 'schCmnz',
          lblCz: {
          },
          bfrIconCz: {
          },
          pslPtyz: {
            onPress: () => $sch({
              sPz: pz.sPz, 
              udtThis: pz.sPz.udtAll,
              sLdrz: _sLdrz,
              pagez: pz.pagez
            }),
          }
        })
      ]
    })
  )
}

export const B = (pz: {
  sPz: _ht.dz,
  cz: {
    dffz: _ht.dz,
  },
  pagez: _ht.dz
}) => {
  return (
    cr.c(GridC.N, {
      key: -20,
      abtType: 'barBtnViewCmnz',
      boxStlz: a('dw/120 bc/lt9 bwb/1'),
      lineCs: [
        {
          cellCs: [
            {
              oClds: [

                cr.c(BtnC.N, {
                  key: -10,
                  abtType: 'nextCmnz',
                  lblCz: {
                    textz: {
                      pfx: 
                        pz.sPz.crt.ctt == 'r' ?
                          `通常${pz.cz.dffz.tgt}`
                        : `${pz.cz.dffz.tgt}`,
                    },
                  },
                  pslPtyz: {
                    onPress: () => {
//                      if (pz.pagez.bLoad == false) {
                        pz.sPz.set({
                          steps: [1],
                          phs: 'crt',
                          _fst: -1,
                        })
//                      }
                    }
                  },
                }),
              ]
            },
            pz.sPz.crt.ctt == 'r' ?
            {
              oClds: [

                cr.c(BtnC.N, {
                  key: -20,
                  abtType: 'nextCmnz',
                  lblCz: {
                    textz: {
                      pfx: '月内一括予約',
                    },
                  },
                  pslPtyz: {
                    onPress: () => {
//                      if (pz.pagez.bLoad == false) {
                        pz.sPz.set({
                          steps: [10],
                        })
//                      }
                    }
                  },
                })
              ]
            }
            : null,
            pz.sPz.crt.ctt == 'r' ?
            {
              oClds: [

                cr.c(BtnC.N, {
                  key: -30,
                  abtType: 'nextCmnz',
                  lblCz: {
                    textz: {
                      pfx: '定期一括予約',
                    },
                  },
                  pslPtyz: {
                    onPress: () => {
//                      if (pz.pagez.bLoad == false) {
                        pz.sPz.set({
                          steps: [11],
                        })
//                      }
                    }
                  },
                })
              ]
            }
            : null,
          ]
        }
      ]
    })
  )
}

export const L = (pz: {
  sPz: _ht.dz,
  frcUdt: () => void,
  cz?: {
    bHome?: _ht.b,
  },
  pagez: _ht.dz,
}) => {

  const _gUserz = gs.useUserz();
  const _gStgz = gs.useStgz();
  const _udtThis = ls.udtThis();
  const _sLdrz = useLdrz();

  React.useEffect(() => {
    if (pz.cz?.bHome) { // 仮押への対応
      icm.ilzPagezAsync(_gUserz.crt._31rz._fst, pz.pagez, {
        sttDate: _hmDTM.getTdy(),
        endDate:_hmDTM.cvtLdm(_hmDTM.addMth(_hmDTM.cvtFdm(_hmDTM.getTdy()), 6)),
      });
      $sch({
        sPz: pz.sPz, 
        udtThis: _udtThis, 
        bHome: pz.cz?.bHome,
        sLdrz: _sLdrz,
        pagez: pz.pagez,
      });
    };
//    _hm.l(`icvI1z___Tz 440: ${pz.sPz.crt.steps[0]}, ${pz.pagez.bSch}`);
//    if (pz.sPz.crt.steps[0] == 0 && $bSch == true) { // 検索後に詳細画面へ遷移し、その後一覧画面へ遷移した場合
    if (pz.sPz.crt.steps[0] == 0 && pz.pagez.bSch == true) { // 検索後に詳細画面へ遷移し、その後一覧画面へ遷移した場合
      //_hm.l(`icvI1z___Tz 441: here`);
      $sch({
        sPz: pz.sPz, 
        udtThis: _udtThis, 
        bHome: pz.cz?.bHome,
        sLdrz: _sLdrz,
        pagez: pz.pagez,
      });
    }
  }, [
    _gStgz.crt.alyMthSttDate,
    _gStgz.crt.alyMthEndDate,
    pz.sPz.crt.steps[0],
  ])

  const _hdrs = [];
  const _cellCs = [
    {
      boxStlz: a('dw/date f/n fd/ccc'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          abtType: 'lblStfz',
          textz: {
            pfx: '利用日'
          }
        })
      ]
    },
    {
      boxStlz: a('fd/ccc'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          abtType: 'lblStfz',
          textz: {
            pfx: '部屋'
          }
        })
      ]
    },
    {
      boxStlz: a('fd/ccc'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          abtType: 'lblStfz',
          textz: {
            pfx: '利用時間帯'
          }
        })
      ]
    },
    {
      boxStlz: a('f/2 fd/ccc'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          abtType: 'lblStfz',
          textz: {
            pfx: '団体番号-団体名'
          }
        })
      ]
    },
    {
      boxStlz: a('fd/ccc'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          abtType: 'lblStfz',
          textz: {
            pfx: '状況'
          }
        })
      ]
    },
    {
      boxStlz: a('fd/ccc'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          abtType: 'lblStfz',
          textz: {
            pfx: '施設'
          }
        })
      ]
    },
    {
      boxStlz: a('dw/6 f/n fd/ccc'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          abtType: 'lblStfz',
          textz: {
            pfx: '経路'
          }
        })
      ]
    },
  ];
  if (pz.sPz.crt.ctt == 'r') {
    _cellCs.push(
      {
        boxStlz: a('dw/icn f/n fd/ccc'),
        oClds: [
          cr.c(TextC.N, {
            key: -10,
            abtType: 'lblStfz',
            textz: {
              pfx: '書類'
            }
          })
        ]
      },
    );
  };
  _cellCs.push(
    {
      boxStlz: a('dw/btn f/n'),
      oClds: [ // 確認ボタン
      ]
    }
  );
  _cellCs.push(
    {
      boxStlz: a('dw/10 f/n fd/ccc'),
      oClds: [
        cr.c(TextC.N, {
          key: -10,
          abtType: 'lblStfz',
          textz: {
            pfx: 'ID',
          }
        })
      ]
    }
  );

  _hdrs.push(
    {
      cellCs: _cellCs
    },
  );

  const _rows = [] as _ht.ls;

  pz.pagez?.i1zrs?.map( ( _i1zrz: _ht.dz, _idx: _ht.n ) => {
    const _cellCs = [
      {
        boxStlz: a('dw/date f/n'),
        oClds: [
          cr.c(TextC.N, { // 利用日
            key: -10,
            textz: {
              pfx: _i1zrz.i1zrd3100s,
            }
          })
        ]
      },
      {
        boxStlz: a('fd/rcc'),
        oClds: [
          cr.c(TextC.N, { // 部屋
            key: -10,
            textz: {
              pfx: _i1zrz.i1zra1100s,
              ptyz: a('tn/1'),
            }
          })
        ]
      },
      {
        boxStlz: a('fd/rcc'),
        oClds: [
          cr.c(TextC.N, { // 利用時間帯
            key: -10,
            textz: {
              pfx: _i1zrz.i1zra1200s,
              ptyz: a('tn/1'),
            }
          })
        ]
      },
      {
        boxStlz: a('f/2 fd/rcc'),
        oClds: [
          cr.c(TextC.N, { // 団体
            key: -10,
            textz: {
              pfx: (_hm.get1(_i1zrz.cldz?.i18rs, {})?.i18rab100s ?? '') + '　'+ (_hm.get1(_i1zrz.cldz?.i18rs, {})?._pfx ?? ''),
              ptyz: a('tn/1'),
            }
          })
        ]
      },
      {
        boxStlz: a('fd/rcc'),
        oClds: [
          cr.c(TextC.N, { // 状況
            key: -10,
            textz: {
              pfx: 
                pz.cz?.bHome ?
                  ihd.r(ihd.f('i1zrs1100i').ls, _i1zrz.i1zrs1100i)
                : pz.sPz.crt.ctt == 'r' ? 
                  ihd.r(ihd.f('i1zrs1100i').ls, _i1zrz.i1zrs1100i)
                : pz.sPz.crt.ctt == 'e' ? 
                  ihd.r(ihd.f('i1zrs1200i').ls, _i1zrz.i1zrs1200i)
                : '',                    
              ptyz: a('tn/1'),
            }
          })
        ]
      },
      {
        boxStlz: a('fd/rcc'),
        oClds: [
          cr.c(TextC.N, { // 施設
            key: -10,
            textz: {
              pfx: _hm.get1(_i1zrz.cldz?._31rs, {})._pfx ?? '',
              ptyz: a('tn/1'),
            }
          })
        ] 
      },
      {
        boxStlz: a('dw/6 f/n fd/rcc'),
        oClds: [
          cr.c(TextC.N, { // 状況
            key: -10,
            textz: {
              pfx: ihd.r(ihd.f('i1zra6100i').ls, _i1zrz.i1zra6100i ?? -1)
            }
          })
        ]
      },
    ];
    if (pz.sPz.crt.ctt == 'r') { // 所属施設の場合
      _cellCs.push(
        {
          //boxStlz: a('dw/13 f/n pl/1'),
          boxStlz: a('dw/icn f/n'),
          oClds: 
          _i1zrz.i1zr_31r1f == _gUserz.crt._31rz._fst ?
          [
            cr.c(BtnC.N, { // 書類
              key: -10,
              boxStlz: a('dw/icn fd/rcc'),
              bfrIconCz: {
                iconPtyz: a('icc/lt9 icn/file-o ics/2'),
              },
              pslPtyz: {
                onPress: () => {
                  pz.sPz.set({
                    steps: [4],
                    phs: 'dpy',
                    i1zr_fst: _i1zrz._fst,
                  })
                },
              }
            })
          ]
          : []
        }
      );
    };
    _cellCs.push(
      {
        boxStlz: a('dw/btn f/n'),
        oClds: 
          _i1zrz.i1zr_31r1f == _gUserz.crt._31rz._fst || 
          (pz.sPz.crt.ctt == 'r' && _hm.i(_i1zrz.i1zrs1100i, [20, 80, 90])) ||
          (pz.sPz.crt.ctt == 'e' && _hm.i(_i1zrz.i1zrs1200i, [20, 70, 80, 90])) ?
          [
            cr.c(BtnC.N, { // 確認ボタン
              key: -10,
              abtType: 'cfmStfz',
              lblCz: {
              },
              pslPtyz: {
                onPress: () => {
                  if ( 
                    pz.cz?.bHome
                  ) {
                    cr.moveTo({
                      pageName: 'icvI1zS10RzR',
                      pmrz: {
                        f: _hm.cvtNbr('e', _i1zrz._fst, icv.srtz.nbrz3),
                      }
                    })
                  }
                  else if ( 
                    ( pz.sPz.crt.ctt == 'r' && _i1zrz.i1zrs1100i == 70 ) ||
                    ( pz.sPz.crt.ctt == 'e' && _i1zrz.i1zrs1200i == 60 )
                  ) {
                    pz.sPz.set({
                      steps: [2],
                      phs: 'crt',
                      i1zr_fst: _i1zrz._fst,
                    })
                  }
                  else {
                    pz.sPz.set({
                      steps: [3],
                      phs: 'dpy',
                      i1zr_fst: _i1zrz._fst,
                    })
                  }
                }
              },
            })
          ]
          : []
      }
    );
    _cellCs.push(
      {
        boxStlz: a('dw/10 f/n fd/ccc'),
        oClds: [ // id
          cr.c(TextC.N, {
            key: -10,
            textz: {
              pfx: _i1zrz._icn,
            }
          })
        ]
      },
    );
    _rows.push(
      {
        boxStlz: 
          _idx == 0 ?
            a('bc/t bwt/1 pt/0.5')
          : a('bc/lt9 bwt/1 pt/0.5'),
        cellCs: _cellCs
      },
    )
  });

  //hf.l(`icvI1z___Ti 908: here`);
  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'cttCmnz',
      oClds: [

        cr.c(TblC.N, {
          key: -20,
          srlCz: {
            abtType: 'cttCmnz',
          },
          hdrCz: {
            abtType: 'hdrStfz',
//            boxStlz: a(`dw/120 mb/0 sc/lt1`),
            boxStlz: a(`mb/0`),
            lineCs: _hdrs,
          },
          bdyCz: {
            abtType: 'lineStfz',
            lineCs: _rows,
            msgCz: {
              boxStlz: a(`mt/1`),
            }
          }
        })

      ]
    })
  );
};
